import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

/**
 * [portalToBody] — mueve el elemento (un `<div bsModal>`) a <body> apenas se
 * crea, para que quede como HERMANO del `.modal-backdrop` (ngx-bootstrap cuelga
 * el backdrop siempre de <body>, z-index 1040; el modal es 1050).
 *
 * Por qué: los bsModal se renderizan "en su lugar" (dentro del componente, que a
 * su vez cuelga de #content/#main). Si CUALQUIER ancestro crea un stacking
 * context —`transform`/`filter` de una extensión (Dark Reader / Auto Dark Mode),
 * el `#content { z-index }` del fix del footer, o el `transform` transitorio de
 * `[@routerTransition]`— el modal (z1050) queda confinado a esa capa y el
 * backdrop de body (z1040) lo TAPA → el modal aparece detrás del backdrop,
 * inutilizable. Viviendo en <body> es inmune a todo eso.
 *
 * Es seguro: ngx-bootstrap opera el modal por REFERENCIA al elemento (show/hide/
 * backdrop/focus no dependen del padre en el DOM; es lo que hace su propio modal
 * service al portalear). Angular actualiza los bindings internos por referencia
 * igual, sin importar dónde esté el nodo.
 *
 * Cleanup: como el nodo se sacó de la vista del componente, al destruirse
 * (`*ngIf`) hay que removerlo a mano de <body> para no dejar un `<div>` huérfano.
 */
@Directive({
    selector: '[portalToBody]'
})
export class PortalToBodyDirective implements AfterViewInit, OnDestroy {

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        const node = this.el.nativeElement;
        if (node) {
            document.body.appendChild(node);
        }
    }

    ngOnDestroy() {
        const node = this.el.nativeElement;
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }
}
